import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getLeasedurations(params) {
        const response = await axios.get(API_URL + "/leasedurations", { headers: authHeader(), params: params });
        return { data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page };
    },

    async addLeaseduration(leaseduration) {
        leaseduration.type = "leasedurations"
        const newJson = dataFormatter.serialize({ stuff: leaseduration })
        const response = await axios.post(API_URL + "/leasedurations", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deleteLeaseduration(leasedurationId) {
        await axios.delete(API_URL + "/leasedurations/" + leasedurationId, { headers: authHeader() });
    },

    async getLeaseduration(leasedurationId) {
        const response = await axios.get(API_URL + "/leasedurations/" + leasedurationId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editLeaseduration(leaseduration) {
        leaseduration.type = "leasedurations"
        const newJson = dataFormatter.serialize({ stuff: leaseduration })
        const response = await axios.patch(API_URL + "/leasedurations/" + leaseduration.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




